/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: wboCjrKjkicgLwUG7d8r4V
// Component: 14ObDxab2_fA

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { _useGlobalVariants } from "../redesigned_credit_storm_landing_app_credit_storm_2/plasmic"; // plasmic-import: wboCjrKjkicgLwUG7d8r4V/projectModule
import { _useStyleTokens } from "../redesigned_credit_storm_landing_app_credit_storm_2/PlasmicStyleTokensProvider"; // plasmic-import: wboCjrKjkicgLwUG7d8r4V/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicFaqItem.module.css"; // plasmic-import: 14ObDxab2_fA/css

import PlusCircleSvgIcon from "./icons/PlasmicIcon__PlusCircleSvg"; // plasmic-import: kb1ZD1SwkHJ7/icon
import MinusCircleSvgIcon from "./icons/PlasmicIcon__MinusCircleSvg"; // plasmic-import: v9Ws_VT4ruDe/icon

createPlasmicElementProxy;

export type PlasmicFaqItem__VariantMembers = {
  open: "open";
};
export type PlasmicFaqItem__VariantsArgs = {
  open?: SingleBooleanChoiceArg<"open">;
};
type VariantPropType = keyof PlasmicFaqItem__VariantsArgs;
export const PlasmicFaqItem__VariantProps = new Array<VariantPropType>("open");

export type PlasmicFaqItem__ArgsType = {
  children?: React.ReactNode;
  slot?: React.ReactNode;
};
type ArgPropType = keyof PlasmicFaqItem__ArgsType;
export const PlasmicFaqItem__ArgProps = new Array<ArgPropType>(
  "children",
  "slot"
);

export type PlasmicFaqItem__OverridesType = {
  root?: Flex__<"div">;
  chevron?: Flex__<"svg">;
  h1?: Flex__<"h1">;
};

export interface DefaultFaqItemProps {
  children?: React.ReactNode;
  slot?: React.ReactNode;
  open?: SingleBooleanChoiceArg<"open">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicFaqItem__RenderFunc(props: {
  variants: PlasmicFaqItem__VariantsArgs;
  args: PlasmicFaqItem__ArgsType;
  overrides: PlasmicFaqItem__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "isOpen",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => false
      },
      {
        path: "open",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.open
      }
    ],
    [$props, $ctx, $refs]
  );

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_wboCjrKjkicgLwUG7d8r4V",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root,
        { [sty.rootopen]: hasVariant($state, "open", "open") }
      )}
    >
      <div
        className={classNames("all", sty.freeBox__v3Pvt, {
          [sty.freeBoxopen__v3PvtVSmj]: hasVariant($state, "open", "open")
        })}
        onClick={async event => {
          const $steps = {};

          $steps["updateIsOpen"] = true
            ? (() => {
                const actionArgs = {
                  variable: {
                    objRoot: $state,
                    variablePath: ["isOpen"]
                  },
                  operation: 4
                };
                return (({ variable, value, startIndex, deleteCount }) => {
                  if (!variable) {
                    return;
                  }
                  const { objRoot, variablePath } = variable;

                  const oldValue = $stateGet(objRoot, variablePath);
                  $stateSet(objRoot, variablePath, !oldValue);
                  return !oldValue;
                })?.apply(null, [actionArgs]);
              })()
            : undefined;
          if (
            $steps["updateIsOpen"] != null &&
            typeof $steps["updateIsOpen"] === "object" &&
            typeof $steps["updateIsOpen"].then === "function"
          ) {
            $steps["updateIsOpen"] = await $steps["updateIsOpen"];
          }

          $steps["updateIsOpen2"] = true
            ? (() => {
                const actionArgs = {
                  vgroup: "open",
                  operation: 2,
                  value: "open"
                };
                return (({ vgroup, value }) => {
                  if (typeof value === "string") {
                    value = [value];
                  }

                  const oldValue = $stateGet($state, vgroup);
                  $stateSet($state, vgroup, !oldValue);
                  return !oldValue;
                })?.apply(null, [actionArgs]);
              })()
            : undefined;
          if (
            $steps["updateIsOpen2"] != null &&
            typeof $steps["updateIsOpen2"] === "object" &&
            typeof $steps["updateIsOpen2"].then === "function"
          ) {
            $steps["updateIsOpen2"] = await $steps["updateIsOpen2"];
          }
        }}
      >
        <div
          className={classNames("all", sty.freeBox__ha2Mb, {
            [sty.freeBoxopen__ha2MbvSmj]: hasVariant($state, "open", "open")
          })}
        >
          <PlasmicIcon__
            data-plasmic-name={"chevron"}
            data-plasmic-override={overrides.chevron}
            PlasmicIconType={
              hasVariant($state, "open", "open")
                ? MinusCircleSvgIcon
                : PlusCircleSvgIcon
            }
            className={classNames("all", sty.chevron, {
              [sty.chevronopen]: hasVariant($state, "open", "open")
            })}
            role={"img"}
          />
        </div>
        <h1
          data-plasmic-name={"h1"}
          data-plasmic-override={overrides.h1}
          className={classNames("all", "h1", "h1__wboCj", sty.h1, {
            [sty.h1open]: hasVariant($state, "open", "open")
          })}
        >
          <div
            className={classNames("all", sty.freeBox__vdDn3, {
              [sty.freeBoxopen__vdDn3VSmj]: hasVariant($state, "open", "open")
            })}
          >
            {renderPlasmicSlot({
              defaultContents: "Mohu si p\u016fj\u010dit na cokoliv?",
              value: args.children,
              className: classNames(sty.slotTargetChildren, {
                [sty.slotTargetChildrenopen]: hasVariant($state, "open", "open")
              })
            })}
          </div>
        </h1>
      </div>
      {(
        hasVariant($state, "open", "open")
          ? true
          : (() => {
              try {
                return $state.isOpen;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return true;
                }
                throw e;
              }
            })()
      ) ? (
        <div
          className={classNames("all", sty.freeBox__qLyas, {
            [sty.freeBoxopen__qLyasVSmj]: hasVariant($state, "open", "open")
          })}
        >
          <div
            className={classNames("all", sty.freeBox__z4Ymq, {
              [sty.freeBoxopen__z4YmqVSmj]: hasVariant($state, "open", "open")
            })}
          >
            {renderPlasmicSlot({
              defaultContents:
                "Ano, klidn\u011b! Nept\u00e1me se, na co pen\u00edze pot\u0159ebujete, tak\u017ee n\u00e1m nemus\u00edte nic dokl\u00e1dat. M\u016f\u017eete je pou\u017e\u00edt t\u0159eba na rekonstrukci, nov\u00e9 auto, dovolenou, elektroniku nebo vzd\u011bl\u00e1n\u00ed. Je to jen na v\u00e1s.",
              value: args.slot,
              className: classNames(sty.slotTargetSlot, {
                [sty.slotTargetSlotopen]: hasVariant($state, "open", "open")
              })
            })}
          </div>
        </div>
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "chevron", "h1"],
  chevron: ["chevron"],
  h1: ["h1"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  chevron: "svg";
  h1: "h1";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicFaqItem__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicFaqItem__VariantsArgs;
    args?: PlasmicFaqItem__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicFaqItem__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicFaqItem__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicFaqItem__ArgProps,
          internalVariantPropNames: PlasmicFaqItem__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicFaqItem__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicFaqItem";
  } else {
    func.displayName = `PlasmicFaqItem.${nodeName}`;
  }
  return func;
}

export const PlasmicFaqItem = Object.assign(
  // Top-level PlasmicFaqItem renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    chevron: makeNodeComponent("chevron"),
    h1: makeNodeComponent("h1"),

    // Metadata about props expected for PlasmicFaqItem
    internalVariantProps: PlasmicFaqItem__VariantProps,
    internalArgProps: PlasmicFaqItem__ArgProps
  }
);

export default PlasmicFaqItem;
/* prettier-ignore-end */
